export default __webpack_public_path__ + "static/media/NeueMontreal-Medium.0f80e0dc.woff";